import { BaseRouteService } from 'core/services';

class ProductVirtualSkuRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'product-virtual-skus/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}',{sourceOfChange});
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource,{sourceOfChange});
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}
}

export default ProductVirtualSkuRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ProductVirtualSkuRouteService.js